import { render, staticRenderFns } from "./SoftTypeIcon.vue?vue&type=template&id=1af56e53&scoped=true&"
import script from "./SoftTypeIcon.vue?vue&type=script&lang=js&"
export * from "./SoftTypeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af56e53",
  null
  
)

export default component.exports